import { render, staticRenderFns } from "./app-business-company-comp.vue?vue&type=template&id=f5c26858&"
import script from "./app-business-company-comp.vue?vue&type=script&lang=js&"
export * from "./app-business-company-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports